// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2NY6q","header":"PatientQuestionnaire_header__3j3lW","info":"PatientQuestionnaire_info__1Taj3"};